/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Link } from '@ta-interaktiv/contentbricks'

const ARTICLE_ID = '867950730931'
const isMobile = window.innerWidth < 600
const isSmallMobile = window.innerWidth < 400

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead inverted articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui container titleImage'>
        <div className='headline'>
          <div className='positioner'>
            <h1>«Auch von Schweden müssen wir lernen»</h1>
            <div className='byline'>
              {isMobile
                ? 'Wie wir ohne neuen Lockdown durch den Winter kommen, sagt Manuel Battegay, Infektiologe und Mitglied der nationalen Covid-Taskforce.'
                : 'Die Corona-Fälle steigen in der Schweiz wieder mit besorgniserregender Geschwindigkeit. Wie wir trotzdem ohne neuen Lockdown durch den Winter kommen, sagt Manuel Battegay, Infektiologe und Mitglied der nationalen Covid-Taskforce.'}
            </div>
          </div>
        </div>
      </header>
      <div className='content'>
        <div className='ui container'>
          <div className='ta secondary caption'>
            {' '}
            Arbeitet seit über 30 Jahren klinisch und wissenschaftlich zum Thema
            Infektionskrankheiten: Prof. Manuel Battegay.
          </div>
        </div>
      </div>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>Marc Brupbacher</div>
            <div className='ta updated'>Aktualisiert am 12. Oktober 2020</div>
          </div>

          <div className='question ta text' style={{ marginTop: '3em' }}>
            Sind wir ehrlich, die Corona-Lage in der Schweiz ist wieder{' '}
            <Link href='378065708166'>ausser Kontrolle</Link> geraten, das
            Contact-Tracing ist in vielen{' '}
            <Link href='316123524329'>Kantonen am Anschlag</Link>.
          </div>
          <div className='answer ta text'>
            Die steigenden Zahlen und Hospitalisationen sind besorgniserregend.
            Wir müssen die etablierten Massnahmen wieder strikter umsetzen, auch
            wenn bei sehr vielen Ermüdungserscheinungen spürbar sind. Die
            Schweiz tut aber gut daran, nicht alarmistisch zu reagieren, denn
            wir haben keine Zustände wie im März und April. Ziel ist es, die
            Infektionsraten möglichst tief zu halten, die verwundbarsten
            Bevölkerungsgruppen zu schützen und das Gesundheitssystem vor einer
            Überlastung zu bewahren.
          </div>

          <div className='question ta text'>
            Die Fallzahlen werden schnell weiter steigen: Grossveranstaltungen
            laufen, Maskenpflicht gibt es nur an beschränkten Orten, es gibt
            keine Personenobergrenze für private Veranstaltungen. Wetter und
            Klima spielen gegen uns.
          </div>
          <div className='answer ta text'>
            Die Reaktion darauf kann nicht sein, überstürzt Massnahmen
            einzuführen, sondern die bereits bestehenden stringenter umzusetzen.
            Wir müssen die Bevölkerung konkreter und verständlicher informieren,
            wie wir uns in alltäglichen Situationen verhalten sollen. Da geht es
            nicht um Vorschriften, sondern um Anleitungen, wie eben soziale
            Kontakte weiterhin möglich sein sollen. Wer zum Beispiel seine
            betagten Grosseltern in der Alterssiedlung besuchen will, sollte 10
            Tage auf Clubbesuche verzichten und so das Risiko minimieren.
          </div>

          <div className='ui ta text biobox container'>
            <img
              className='ui medium circular image centered'
              src={require('../../images/bio.jpg')}
            />
            <div className='names'>Manuel Battegay</div>
            Manuel Battegay ist seit 2002 Chefarzt der Klinik Infektiologie &
            Spitalhygiene am Universitätsspital Basel, tätig ist er dort seit
            1994. Er ist im Leitungsteam der Swiss National Covid-19 Science
            Task Force.
          </div>

          <div className='question ta text'>
            Die Kantone haben es doch verpasst, das Virus seit dem 1. Juni, als
            die Zahlen wieder exponentiell zu steigen begannen, einzudämmen. Hat
            der Bund die Öffnung nicht zu schnell vorangetrieben?
          </div>
          <div className='answer ta text'>
            Die Geschwindigkeit der Öffnung spielt praktisch keine Rolle,
            entscheidend sind der Grad der Öffnung und die flankierenden
            Massnahmen. Länder, die ständig vom Lockdown zur Normalität und
            zurück wechseln, führen einen Zickzackkurs, den ich für sehr
            schädlich halte. Wenn die Anzahl der Übertragungen auf einem tiefen
            Niveau ist, wie es Anfang Sommer der Fall war, nützt es überhaupt
            nichts, lange mit der Öffnung zuzuwarten. Dies schädigt nur das
            gesellschaftliche Leben und die Wirtschaft, denn das Virus bleibt
            da. Ein Lockdown ist keine Option, auch wenn wir eines der wenigen
            Länder in Europa wären, die dies nicht tun. Es wäre ein Versagen und
            würde zeigen, dass wir uns nicht rigoros an die Massnahmen gehalten
            hätten.
          </div>

          <div className='question ta text'>
            Das hört sich nach dem Weg der Schweden an, die auf Gebote statt
            Verbote setzen. Das Land hat aber zurzeit mit der
            Homeoffice-Empfehlung und dem Versammlungsverbot von mehr als 50
            Personen striktere Regeln als wir in Kraft.
          </div>
          <div className='answer ta text'>
            Auch von Schweden müssen wir lernen. Gut am schwedischen Weg ist die
            Beständigkeit. Aber auch Schweden hat deutlich nachkorrigiert, denn
            der Schutz vulnerabler Menschen war ungenügend. Wenn wir nun seit
            Monaten deutlich liberaler als Schweden unterwegs sind, müssen wir
            umso disziplinierter sein, nur dann funktioniert das Schweizer
            Konzept. Und wir müssen bereit sein, ständig zu adaptieren.
          </div>

          <div className='quote-element'>
            <p className='quote'>
              «Nur negative Corona-Meldungen hält niemand aus»
            </p>
          </div>

          <div className='question ta text'>
            Müssen wir uns bald eingestehen, dass die Eindämmungs- und
            Teststrategie gescheitert ist, und zu einer Durchseuchungsstrategie
            übergehen, wo man die Risikogruppen abschirmt, bis ein Impfstoff da
            ist?
          </div>
          <div className='answer ta text'>
            Die Eindämmungsstrategie muss weiterverfolgt werden, denn
            Durchseuchen würde zu viel Leid verursachen. Wir haben in anderen
            Ländern gesehen, dass das Gesundheitswesen, aber auch die Wirtschaft
            dadurch zu stark belastet wird. Wir werden Risikogruppen nie ganz
            abschirmen können. Wenn sich nun aber viele Junge angesteckt haben
            und anstecken, sollte dies dennoch zur Herdenimmunität beitragen.
          </div>

          <div className='question ta text'>
            Ihr Kollege <Link href='458152475441'>Marcel Tanner sagt</Link>,
            wenn Risikogruppen geimpft sind, könne man beim Rest der Bevölkerung
            an eine Durchseuchung denken. So was hat man bisher noch von keinem
            Taskforce-Mitglied gehört. Auch junge, gesunde Menschen wollen doch
            nicht durchseucht werden, sondern sich ebenfalls impfen lassen.
          </div>
          <div className='answer ta text'>
            Wenn die Impfung vulnerable Menschen zu 80 Prozent vor der Krankheit
            schützt, dann könnten Massnahmen tatsächlich zusehends gelockert
            werden, ohne dass alle schon geimpft sind. Dieses Konzept könnte
            beim Weg zurück zur Normalität helfen, denn eine Impfung wird
            kontinuierlich ausgerollt werden und ist nicht von Beginn weg für
            alle verfügbar. Es sollten sich aber möglichst viele impfen lassen,
            man denke beispielsweise auch an den Schutz Schwangerer.
          </div>

          <div className='question ta text'>
            Die Zahl der Hospitalisierten hat sich in der Schweiz innerhalb
            eines Monats fast verdoppelt. Sind die Spitäler gewappnet?
          </div>
          <div className='answer ta text'>
            Wir sind gewappnet, aber klar, die Kapazitäten sind nicht
            unbeschränkt. Wir schauen täglich auf die Zahl von neuen
            Hospitalisationen und die Belegung der Intensivstationen. Da stossen
            wir noch an keine Grenzen. Ebenfalls werden kontinuierlich Daten zur
            Sterblichkeit und den damit zusammenhängenden Risikofaktoren in 20
            Spitälern in einer Studie des Bundesamtes für Gesundheit (BAG)
            erhoben. Den Kliniken werden ständig die neuesten Ergebnisse
            übermittelt.{' '}
          </div>

          <div className='quote-element'>
            <p className='quote'>
              «Spitäler müssen bereit sein für einen intensiven Winter»
            </p>
          </div>

          <div className='question ta text'>
            Ist es nicht zynisch, wenn die Behörden sagen, solange die Spitäler
            noch nicht voll seien, gebe es keinen akuten Handlungsbedarf?
          </div>
          <div className='answer ta text'>
            In einer solchen Krise besteht immer Handlungsbedarf. Ich kann Ihnen
            versichern, die Arbeit hinter den Kulissen aller
            Gesundheitsfachpersonen, seitens des Bundes, des BAG und der Kantone
            ist immens. Es geht aber auch darum, die Pandemie in die tagtägliche
            Tragik und das Leid einzuordnen, das wir sonst erleben. Grosse Teile
            der Bevölkerung haben hier ein gutes Gespür: Nicht nur Ältere und
            Betagte wissen, dass dies eine schlimme Krankheit ist, immer ein
            Risiko mitspielt, wir aber mit dem Virus leben müssen, und wissen,
            dass ein absoluter Schutz nicht möglich ist. Dann lese ich in den
            Medien viel zu selten Geschichten über Anlässe, die mit einem
            kreativen Schutzkonzept umgesetzt wurden oder wie Altersheime die
            schwierige Situation gut meistern. Nur negative Meldungen hält
            niemand aus, und international stehen wir ja auch nicht so schlecht
            da, da dürfen wir auch Positives vermelden.{' '}
          </div>

          <div className='question ta text'>
            Wie kommen wir durch den Winter?
          </div>
          <div className='answer ta text'>
            In Richtung Lockdown zu gehen, halte ich für falsch. Es werden viele
            Freiheiten möglich sein, wenn wir uns an die etablierten Massnahmen
            halten. In all den Gremien und Institutionen arbeiten wir nicht, um
            Dinge zu verbieten, sondern um Leben möglichst gut zu schützen und
            trotzdem nicht alles lahmlegen zu müssen. Am wichtigsten ist eine
            aktivere Kommunikation, damit jeder noch besser weiss, dass sehr
            vieles von der disziplinierten Anwendung der Schutzregeln abhängt.
            Hände waschen respektive desinfizieren, Distanz wahren und Masken
            tragen. Über das Einschränken der Versammlungsgrösse oder die
            Ausweitung der Maskenpflicht sollte situativ in den Kantonen
            entschieden werden. Klar ist aber auch, Spitäler und die alle
            Gesundheitsfachpersonen müssen bereit sein für einen intensiven
            Herbst und Winter.
          </div>

          <div className='question ta text'>
            Soll man Masken tragen, wann immer es geht?
          </div>
          <div className='answer ta text'>
            Ganz klar ja, in Innenräumen, wo Menschen eng zusammenkommen, sind
            sie sehr effektiv. Aber auch in Fussballstadien, wo laut gerufen und
            geschrien wird, nützen sie. Durch die Maske wird auch das sogenannte
            Inokulum, also die Menge an eingeatmeten Viren reduziert und dadurch
            die Schwere der Krankheit gemildert, wie jüngst{' '}
            <Link href='https://www.nature.com/articles/d41586-020-02801-8'>
              in Tierversuchen gezeigt wurde
            </Link>
            . Wenn alle die Maske tragen, ergibt sich zudem ein additiver
            Schutzeffekt. Der eindrücklichste Beleg, dass Masken schützen, sieht
            man in den Spitälern und Praxen der Schweiz. Meines Wissens ist
            keine Gesundheitsfachperson in der Schweiz an Covid-19 verstorben,
            während es in Italien an die 300 Todesfälle unter Ärztinnen, Ärzten
            und Pflegenden gab. Und Italien beklagte ja ein immenses
            Schutzproblem zu Beginn der Pandemie.
          </div>

          <div className='question ta text'>
            Braucht es wieder eine Homeoffice-Empfehlung?
          </div>
          <div className='answer ta text'>
            Jein. Wenn die Hospitalisationszahlen wieder stark ansteigen, dann
            ja, und wenn die Büros klein sind, auch. Aber in den Spitälern
            arbeiten wir nun seit Monaten mit Schutzmasken und sehen fast keine
            Ansteckungen. Trotzdem ist dies ein gutes Mittel, auch den
            Pendlerverkehr zu reduzieren. Diese Empfehlung muss aber nicht
            flächendeckend sein.
          </div>

          <div className='question ta text'>
            Sollen die Clubs wieder schliessen?
          </div>
          <div className='answer ta text'>
            Für Clubs bräuchte es noch klarere Vorschriften. Beispielsweise
            müsste die Musiklautstärke gedrosselt werden, damit Leute nicht
            schreien müssen, um sich zu verständigen. Gegebenenfalls müssen
            Clubs und Bars aber im Winter einige Monate lang geschlossen werden.
          </div>

          <div className='question ta text'>
            Müssen Grossveranstaltungen jetzt wieder verboten werden?
          </div>
          <div className='answer ta text'>
            Das sollten wir erst dann empfehlen, wenn wir gesehen haben, dass
            sie wirklich ein erhöhtes Risiko darstellen. Auch hier warne ich vor
            vorschnellen Schritten. Wenn die Besucher sich an die Schutzkonzepte
            halten – vor allem auch vor und nach den Anlässen –, müssten sie
            möglich sein. Auch wenn das Wort Disziplin nicht beliebt ist, hier
            braucht es sie.
          </div>

          <div className='question ta text'>
            Wie sieht es mit den Schulen aus? Die Schulöffnungen seien der
            Treiber der hohen Corona-Fallzahlen in Israel gewesen, sagt{' '}
            <Link href='https://www.tagesanzeiger.ch/corona-lektionen-aus-israel-499729701264'>
              Eran Segal
            </Link>
            , einer der führenden Covid-19-Statistiker des Landes. Er rät: Keine
            offenen Schulen bei stark steigenden Fallzahlen.
          </div>
          <div className='answer ta text'>
            Ich kenne diese Interpretation und stelle sie infrage. Denn wir
            hätten Ähnliches in der Schweiz und Deutschland auch sehen müssen.
            Zudem wären viel mehr Lehrpersonen erkrankt. In Israel lebt eine
            aktive, junge Bevölkerung, die sich gerne trifft. Zudem fanden viele
            Übertragungen bei orthodoxen Familien statt, wo die Wohnsituation
            häufig viel enger ist als in der Schweiz. Oder es gab Ausbrüche bei
            Feiern oder Demonstrationen ohne Schutzkonzepte. Dass diese
            Übertragungen vor allem an Schulen geschehen sein sollen, ist
            vorerst eine Hypothese, die wissenschaftlich nicht erhärtet ist.
          </div>

          <div className='question ta text'>
            Wie gehen Sie selber mit der Situation um? Gehen Sie noch in
            Restaurants?
          </div>
          <div className='answer ta text'>
            Ja, denn ich bin von den Schutzkonzepten überzeugt. Ich achte sehr
            auf Hygiene, Abstand und trage in vielen Situationen eine Maske. Wie
            jemand mit Restrisiken umgehen will, ist jedem selbst überlassen. Da
            ich 60 Jahre alt bin, habe ich mit meiner Frau und unseren Kindern
            besprochen, was wäre, wenn jemand von uns schwer erkranken oder
            sterben würde. Als Ärzte wissen wir, das nimmt Angst weg. Es wäre
            ohnehin gut, wenn wir uns ab und zu mit unserer Endlichkeit
            auseinandersetzen würden, nicht nur im Zusammenhang mit Covid-19.
          </div>

          <div className='question ta text'>
            Soll man dieses Jahr auf Weihnachten im erweiterten Familienkreis
            verzichten?
          </div>
          <div className='answer ta text'>
            In der Familie feierten wir kürzlich die hohen jüdischen Feiertage,
            wo wir mit unseren betagten Müttern zusammen waren. Wir haben sehr
            darauf geschaut, dass die Abstände grösser waren als sonst und
            regelmässig gelüftet wurde. Wir haben auch auf Umarmungen
            verzichtet. Ich bin der festen Überzeugung, dass hier die
            Eigenverantwortung wichtig ist. Für mich ist religiöse Gemeinschaft
            sinnstiftend, und so ist es für viele Menschen hier und weltweit.
          </div>

          <div className='question ta text'>
            Wie sehr fürchten Sie sich vor der Grippe dieses Jahr?
          </div>
          <div className='answer ta text'>
            Die Situation auf der Südhalbkugel zeigt, dass die Grippe,
            wahrscheinlich wegen der präventiven Massnahmen, praktisch ausblieb.
            Wir zeigten in einer kürzlich{' '}
            <Link href='806586117625'>publizierten Studie</Link> aus Basel, dass
            gleichzeitige Infektionen mit Sars-CoV-2 und Influenza selten waren.
            Trotzdem soll man sich entsprechend den Empfehlungen dieses Jahr
            gegen die Grippe impfen lassen. Zudem gibt es mit Tamiflu ein
            Medikament, das, wenn es in den ersten Stunden gegeben wird, sehr
            gut wirkt. Trotzdem besteht die Gefahr, dass die Spitäler durch
            zusätzliche Winterviren gesamthaft sehr viel Last tragen werden. Und
            es ist möglich, dass wir Eingriffe, die nicht absolut dringend sind,
            für ein paar Wochen wieder reduzieren müssen.
          </div>

          <div className='question ta text'>
            Wie sieht es an der Therapiefront aus? Die teilwirksamen Mittel wie
            Remdesivir und Dexamethason wurden relativ schnell entdeckt. Jetzt
            passierte aber lange nichts mehr. Warum nicht?
          </div>
          <div className='answer ta text'>
            Remdesivir war ein schon vorhandenes Medikament, und Dexamethason
            ist schon fast als uralt zu bezeichnen. Die Spitalsterblichkeit lag
            in der Schweiz mit rund 10 Prozent gemäss einem Vergleich der OECD
            weltweit am tiefsten. Dies stellt nicht nur den Spitälern in der
            Schweiz ein gutes Zeugnis aus, sondern auch den Kolleginnen und
            Kollegen in der Praxis. Die Betreuung von Patienten mit Risiken wie
            Diabetes, Hypertonie, kardiovaskulären Risiken oder Übergewicht ist
            hierzulande beispielhaft. Da bei Covid-19 vor allem die ausgelöste
            Entzündung Schäden verursacht, ist die optimale Einstellung dieser
            Krankheiten entscheidend. Neue Medikamente werden entwickelt, aber
            das geht nicht so schnell.
          </div>

          <div className='question ta text'>
            Sind experimentelle Antikörper-Medikamente wie das von Regeneron,
            welches auch US-Präsident Trump gegeben wurde, vielversprechend?
            Setzt man sie in der Schweiz schon ein?
          </div>
          <div className='answer ta text'>
            Ja, für mich ist dies aktuell der vielversprechendste Ansatz.
            Schweizerische Zentren wurden für Studien mit diesen Medikamenten
            angefragt, aber die Therapien haben noch nicht begonnen. Aus meiner
            Sicht wäre es auch gut, die Plasmatherapien weiterzuverfolgen,
            zumindest solange Antikörper-Medikamente nicht breit verfügbar sind.
          </div>

          <div className='question ta text'>
            Was sind die Unterschiede bei der Behandlung von hospitalisierten
            Covid-Patienten im Vergleich zum April? Welche Therapien setzen Sie
            in Basel ein?
          </div>
          <div className='answer ta text'>
            Insgesamt konnte die Behandlung optimiert werden. Wir haben ein
            schweizweites und nicht ein Basler Therapiekonzept, das sich immer
            nach der neuesten Evidenz richtet. Remdesivir wird jetzt im
            Gegensatz zur ersten Phase viel früher gegeben. Ob es die
            Sterblichkeit auch bei nicht beatmeten Patienten senkt, wissen wir
            noch nicht. Dexamethason wird entsprechend Studienresultaten nun
            auch früher und viel häufiger eingesetzt, es wird jetzt praktisch
            jedem hospitalisierten Patienten gegebene. Klar gezeigt hat sich
            hingegen, dass Hydroxychloroquin und Kaletra nicht wirken. Dann
            werden in verschiedenen schweizerischen Zentren hoffentlich bald neu
            entwickelte Medikamente wie Proteasehemmer eingesetzt, welche die
            Virusvermehrung mindern sollen.
          </div>

          <div className='question ta text'>
            Viele zusätzliche Möglichkeiten bei der Behandlung hat man also
            nicht.
          </div>
          <div className='answer ta text'>
            Nein, aber es ist dennoch Spitzenmedizin, die in der Schweiz seit
            dem Beginn der Epidemie betrieben wird. Die Vorstellung, «einfach»
            Patienten zu beatmen, ist falsch. Ein Patient auf der
            Intensivstation wird für die Diagnostik und Therapie durch das Team
            der Intensivmediziner und der Intensivpflege sowie durch Teams wie
            Herz-, Lungen-, Nieren-, Gerinnungsspezialisten, Radiologen,
            Infektiologen und aus weiteren Disziplinen mitbetreut. Und bei
            hospitalisierten Patienten auf Normalstation ist die Betreuung
            ebenfalls interdisziplinär.
          </div>

          <div className='question ta text'>
            Alle schauen auf die Spitäler, ob die schon voll sind. Kaum jemand
            beachtet die Langzeitsymptomatik bei Covid. Eine aktuelle
            <Link href='https://www.rts.ch/info/suisse/11661548-un-malade-du-covid-sur-trois-met-plusieurs-mois-pour-sen-remettre.html'>
              Untersuchung aus Lausanne
            </Link>{' '}
            zeigt: 30% der mild erkrankten Patienten sind auch nach Monaten
            nicht gesund. Es besteht die Gefahr einer Chronifizierung. Warum
            sprechen die Gesundheitsbehörden und auch die Taskforce in der
            Schweiz so wenig über dieses Thema?
          </div>
          <div className='answer ta text'>
            Das Thema ist wichtig und ernst zu nehmen. Die Taskforce verfasst
            zurzeit ein Dokument über Langzeitfolgen. Die Zahlen, die Sie
            nennen, scheinen mir aber viel zu hoch, denn nach milden Verläufen
            gehen viele nicht zum Arzt. Klar ist aber, dass Folgeschäden
            vorübergehend an Lunge, Herz und Gehirn vorhanden sein können. Es
            besteht aber selbst bei schwer kranken Patienten eine starke
            Erholungstendenz, die aber Monate dauern kann.
          </div>

          <div className='question ta text'>
            Woher kommt diese Fixierung auf die Todesfälle und Hospitalisierten?
            Das Verhindern von chronischen Langzeitfolgen bei jungen Menschen,
            die mitten im Leben stehen, Kinder und Job haben, scheint doch
            wichtiger.
          </div>
          <div className='answer ta text'>
            Die Betreuung von Patientinnen und Patienten mit meist schweren
            Infektionskrankheiten ist die Hauptaufgabe von uns Infektiologen im
            Spital. Wir sind häufig mit der Frage nach Langzeitschäden
            konfrontiert. Auch bei anderweitigen Lungenentzündungen, die auch
            andere Organe betreffen können, informieren wir Patienten, dass
            selbst nach milderen Verläufen eine Genesung Wochen, ja Monate in
            Anspruch nehmen kann. Bei Covid-19 gibt es noch keine gute
            Datenlage. Weder bei schweren noch milden Verläufen wissen wir, wie
            gross der Anteil der Patienten mit chronischen, möglicherweise
            irreversiblen Schäden ist.
          </div>

          <div className='question ta text'>
            Hat man es in der Schweiz verpasst, rechtzeitig zu untersuchen, wie
            es denn den Zehntausenden Erkrankten vom März/April heute geht, um
            davon Massnahmen für den Winter abzuleiten?
          </div>
          <div className='answer ta text'>
            Eine schwierige Frage. Ähnlich wie bei der HIV-Kohortenstudie wäre
            es wichtig, zumindest Patienten, die im Spital oder in der Praxis
            betreut wurden, engmaschig nachzubetreuen.
          </div>

          <div className='quote-element'>
            <p className='quote'>
              «Das Schlimmste dürfte im April 2021 überstanden sein»
            </p>
          </div>

          <div className='question ta text'>
            Gehen Sie nach wie vor davon aus, dass im Laufe des nächsten Jahres
            ein oder mehrere Impfstoffe verfügbar sein werden? Werden diese die
            Epidemie in der Schweiz beenden?
          </div>
          <div className='answer ta text'>
            Ich bin zuversichtlich, dass Impfstoffe verfügbar sein werden.
            Sars-CoV-2 ist eine akute Viruskrankheit, die, wenn sie nicht
            tödlich verläuft, nie eine chronische Infektion verursacht, das
            heisst, das Virus wird selbst nach schweren Verläufen eliminiert.
            Ebenso werden neutralisierende Antikörper von rund 85 Prozent der
            infizierten Menschen gebildet. Bereits in den{' '}
            <Link href='https://vac-lshtm.shinyapps.io/ncov_vaccine_landscape/'>
              nächsten Monaten
            </Link>{' '}
            werden erste Ergebnisse von Impfstudien publiziert werden. Dann
            werden wir wissen, wie sicher und effektiv die Mittel sein werden.
            Nicht alle meiner Kolleginnen und Kollegen sind hinsichtlich der
            Zeitachse zur Entwicklung eines Impfstoffes so zuversichtlich. Auch
            das Ausrollen der Impfstoffe wird dann aber noch mehrere Monate in
            Anspruch nehmen. Das Virus wird weiter zirkulieren.
          </div>

          <div className='question ta text'>
            In der Schweiz will sich nur ungefähr die Hälfte gegen Sars-CoV-2
            impfen lassen. Sind Sie alarmiert?
          </div>
          <div className='answer ta text'>
            Nein, es ist verständlich, dass viele abwarten wollen, wie die
            Wirkung und die Sicherheit des Impfstoffes ist. Und eine Impfung
            wird ja nicht durch eine Maschine verabreicht, sondern findet in
            einem vertrauensvollen Umfeld statt. Wir müssen unbedingt vom Wort
            «Massenimpfung» wegkommen. Wir haben hier in der Schweiz ein gutes
            und dichtes Gesundheitswesen, das zu Recht Vertrauen geniesst. Eine
            Impfung wird wie bis anhin mit einer sorgfältigen Besprechung
            einhergehen. Und niemand wird gezwungen!
          </div>

          <div className='question ta text'>
            Braucht es ein Impfobligatorium zumindest für bestimmte
            Berufsgruppen?
          </div>
          <div className='answer ta text'>
            Für die breite Bevölkerung und auch für Berufsgruppen braucht es das
            nicht. Denkbar ist es für bestimmte Tätigkeiten im
            Gesundheitsbereich. In erster Linie sollten wir darauf setzen,
            Personen mit engem Kontakt zu besonders gefährdeten Patienten
            prioritär zu impfen.
          </div>

          <div className='question ta text'>
            Woher kommt diese Impfskepsis in der Schweiz?
          </div>
          <div className='answer ta text'>
            Dies fragten wir uns auch, weshalb wir{' '}
            <Link href='https://europepmc.org/article/med/32199740'>
              eine Studie
            </Link>{' '}
            bei der Grippeimpfung durchgeführt haben. Angst vor Nebenwirkungen
            und die Fremdbestimmung wurden als Hauptgründe genannt. Die
            Menschheit hat in unglaublichem Ausmass von Impfungen profitiert.
            Wir erleben jetzt einmal mehr auf tragische Weise, dass
            Infektionskrankheiten die Menschheit als Geisel nehmen können. Dass
            Impfungen der vielleicht grösste medizinische Fortschritt der
            Menschheit sind, ist bei uns hier als reiches Land vielleicht
            stärker in Vergessenheit geraten als bei Menschen in ärmeren
            Ländern. Da sollten wir vielleicht etwas demütiger sein und
            Impfungen, die sicher sind, als etwas Gutes sehen.
          </div>

          <div className='question ta text'>
            Ganz grundsätzlich hat man das Gefühl, die Zahl der Corona-Skeptiker
            wachse, die behaupten, Masken nützten nichts, PCR-Tests seien
            unzuverlässig, das Virus gar nicht so gefährlich. Wie geht man damit
            um?
          </div>
          <div className='answer ta text'>
            Als Ärzte und Pflegende begleitet uns Skepsis durchs ganze
            Berufsleben – und das ist gut so. Viele Menschen wollten zu Beginn
            keine HIV-Therapie, aber wenn es um Leben oder Tod ging, habe ich
            ohne eine einzige Ausnahme seit 1988 niemanden gesehen, der auf
            diese verzichtet hätte. Wir dürfen nicht vergessen: Auch als
            Kliniker ist man immer ein bisschen am Zweifeln, ob man das Richtige
            tut, denn sonst irrt man schnell. Mühe habe ich mit Personen, die
            abstruses behaupten, zum Beispiel, es gebe das Virus nicht. Und um
            es hier nochmals klar zu sagen, Covid-19 ist ca. 10- bis 15-mal so
            tödlich wie eine Grippe, wie eine{' '}
            <Link href='https://www.medrxiv.org/content/10.1101/2020.07.23.20160895v6'>
              neue Studie
            </Link>{' '}
            zum wiederholten Mal zeigt.
          </div>

          <div className='question ta text'>
            Ich habe Sie das vor{' '}
            <Link href='782139135771'>einem halben Jahr</Link> schon einmal
            gefragt: Wie wird das Leben in der Schweiz im April 2021 aussehen?
          </div>
          <div className='answer ta text'>
            Ich bleibe dabei, dass uns die Epidemie bis Ende 2021 beschäftigen
            wird, allerdings mit der Zuversicht auf einen recht baldigen
            Impfstoff, möglicherweise Mitte 2021, und dem Wissen, dass es in
            diesem Sommer recht gut ging. Das Schlimmste dürfte im April 2021
            überstanden sein.
          </div>
        </div>
      </div>

      <Footer
        articleId={ARTICLE_ID}
        questions={['Wie informativ war das Interview?']}
        credits={[
          ['Interview', 'Marc Brupbacher'],
          ['Digitale Umsetzung', 'Mathias Lutz']
        ]}
        hidePortfolioTeaser
      />
    </div>
  )
}
